import React from "react";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useSearchParams, useLocation, matchPath } from 'react-router-dom'
import Select from "react-select";
import axios from "axios";
import SglContext from '../SglContext'

function LiveClassWidget(props) {
  const navigate = useNavigate();
  const [rings, setRings] = useState(0);
  const [rings_data, setRingsData] = useState([]);
  const [rings_keys, setRingsKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const Sgl = useContext(SglContext)

  useEffect(() => {
    fetchLiveClassWidgetData();
  }, []);

  function fetchLiveClassWidgetData() {
    let timestamp = Date.now();

    const webservice_liveclass_widget =
      Sgl.sglApiUrl +
      "/iphone.php/" +
      Sgl.company_urlpath +
      "/webservice/LiveScoreWidget";
    axios
      .post(
        webservice_liveclass_widget,
        {
          datetimestamp: timestamp,
          customer_id: Sgl.company_id,
          from_wp_api: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        var empty_live_data = false;
        if (Object.keys(res.data).length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const rings = Object.keys(res.data[i]["live_data"]);
            setRingsData(res.data[i]["live_data"]);
            setRingsKeys(rings);
       
            
            // rings.forEach((key, index) => {
            //   let ring = res.data[i]["live_data"][key];
            //   setRingNames((ringNames) => [...ringNames, ring.name]);
            //   setRingLiveNow((ringLiveNow) => [...ringLiveNow, ring.livenow]);
            //   setRingUpcoming((ringUpcoming) => [
            //     ...ringUpcoming,
            //     ring.upcoming,
            //   ]);
            //   setRingCompleted((ringCompleted) => [
            //     ...ringCompleted,
            //     ring.completed,
            //   ]);
            //   if (
            //     ring.livenow !== undefined ||
            //     ring.upcoming !== undefined ||
            //     ring.completed !== undefined
            //   ) {
            //     let rows = 0;
            //     let classGroups;
            //     if (ring.livenow !== null && ring.livenow !== undefined) {
            //       classGroups = Object.keys(ring.livenow);

            //       classGroups.forEach((keyLive, index) => {
            //         var classGroup = ring.livenow[keyLive];
            //         rows += 1;

            //         setLiveGroupName((liveGroupName) => [
            //           ...liveGroupName,
            //           classGroup.group_name,
            //         ]);
            //         setLiveClassNumber((liveClassNumber) => [
            //           ...liveClassNumber,
            //           classGroup.class_numbers,
            //         ]);
            //         setLiveTrip((liveTrip) => [...liveTrip, classGroup.trips]);
            //         setLiveLink((liveLink) => [...liveLink, classGroup.link]);
            //       });
            //     }

            //     if (ring.upcoming !== null && ring.upcoming !== undefined) {
            //       classGroups = Object.keys(ring.upcoming);

            //       classGroups.forEach((keyUpcoming, index) => {
            //         var classGroup = ring.upcoming[keyUpcoming];

            //         if (rows >= 2) {
            //           return;
            //         }

            //         rows += 1;
            //         setUpcomingGroupName((upcomingGroupName) => [
            //           ...upcomingGroupName,
            //           classGroup.group_name,
            //         ]);
            //         setUpcomingClassNumber((upcomingClassNumber) => [
            //           ...upcomingClassNumber,
            //           classGroup.class_numbers,
            //         ]);
            //         setUpcomingTime((upcomingTime) => [
            //           ...upcomingTime,
            //           classGroup.time,
            //         ]);
            //         setUpcomingLink((upcomingLink) => [
            //           ...upcomingLink,
            //           classGroup.link,
            //         ]);
            //       });
            //     }
            //     if (ring.completed !== null && ring.completed !== undefined) {
            //       classGroups = Object.keys(ring.completed);

            //       classGroups.forEach((keyCompleted, index) => {
            //         var classGroup = ring.completed[keyCompleted];
            //         if (rows >= 2) {
            //           return;
            //         }
            //         rows += 1;

            //         setCompletedGroupName((completedGroupName) => [
            //           ...completedGroupName,
            //           classGroup.group_name,
            //         ]);
            //         setCompletedClassNumber((completedClassNumber) => [
            //           ...completedClassNumber,
            //           classGroup.class_numbers,
            //         ]);
            //         setCompletedLink((completedLink) => [
            //           ...completedLink,
            //           classGroup.link,
            //         ]);
            //       });
            //     }
            //   }
            // });
          }
        }
        // if (empty_live_data) {
        //   var live_btn_desktop = document.getElementById(
        //     "live-class-btn-desktop"
        //   );
        //   var live_btn_mobile = document.getElementById("live-class-btn");
        //   if (live_btn_desktop) {
        //     live_btn_desktop.style.display = "none";
        //   }
        //   if (live_btn_mobile) {
        //     live_btn_mobile.style.setProperty("display", "none", "important");
        //   }
        // } else {
        //   var live_btn_desktop = document.getElementById(
        //     "live-class-btn-desktop"
        //   );
        //   var live_btn_mobile = document.getElementById("live-class-btn");
        //   if (live_btn_desktop) {
        //     live_btn_desktop.classList.add("desktop-button-show");
        //   }
        //   if (live_btn_mobile) {
        //     live_btn_mobile.classList.add("mobile-button-show");
        //   }
        // }
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
      });
  }
  

  // if (loading) {
  //   return null;
  // }

    if (loading) {
      return (
        <div className='popuptext_data' id='myPopupData'>
          <div className='popup-loader'></div>
        </div>
      );
    }

    return (
        <div className='popuptext_data ' id='myPopupData'>
        {/* <div className='popup-loader'></div> */}
        <table
          border='0'
          cellSpacing='0'
          cellPadding='0'
          className='LiveClassHeader'>
          <tr>
            <td
              style={{
                verticalAlign: "middle",
                padding: "0px 1px",
                textAlign: "center",
                fontWeight: "bold",
              }}>
              <span
                style={{
                  marginTop: "3px !important",
                  paddingTop: "0px",
                  display: "inline-block",
                }}>
                LIVE NOW
              </span>
              <button
                style={{ float: "left", fontSize: "12px" }}
                onClick={props.closePopup}
                className='close-panel button top-btn'>
                Close
              </button>

              <button 
                style={{ float: "right", fontSize: "12px" }}
                onClick={(e) => {
                  e.preventDefault();
                  props.closePopup();
                  navigate("/liveclass");
                }}
                name='btnViewAll'
                id='btnViewAll'
                title='View All'
                type='button'
                className='button top-btn'>
                View All
              </button>
            </td>
          </tr>
        </table>
        <div id='ringWrapperLU' className='ui-sortable'>
                {rings_keys.map((key, index) => {
                    let rows = 0;
                    let ring = rings_data[key];
                    // let liveClassGroups = Object.keys(ring.livenow);

                    if (!ring) {
                      return null;
                    }

                    return (
                    <>
                      {/* <div>{ring}</div> */}
                        {(ring.livenow !== undefined || ring.upcoming !== undefined || ring.completed !== undefined) &&
                            <div expanded="0" id="1" className="ring ui-corner-all ui-widget">
                                <div className="ring-header">
                                    <div className="ui-widget-header ui-corner-top"><span className="ring-title">{ring.name?ring.name:'-'}</span></div>
                                        <ul style={{border: '1px solid #dddddd',
                                            background: '#ffffff',
                                            color: '#333333'}}
                                            
                                        className="ring-summary ui-widget-content ui-corner-bottom">
                                
                                        {(ring.livenow !== null && ring.livenow !== undefined) &&
                                        <>
                                          {ring.livenow.map((classGroup, index) => {
                                            rows += 1;
                                            return (
                                            <li className="ring-row-wrapper">
                                                <span className="liveclass_nameinfo">
                                                    <Link onClick={props.closePopup} to={classGroup.link}>{classGroup.group_name+' ('+classGroup.class_numbers+')'}</Link>
                                                </span>
                                                <span className="live_status">
                                                    <Link onClick={props.closePopup} to={classGroup.link}>{classGroup.trips}</Link>
                                                </span>
                                            </li>
                                            )
                                          
                                          })}
                                        </>}
                                        {(ring.upcoming !== null && ring.upcoming !== undefined) &&
                                        <>{
                                          ring.upcoming.map((classGroup, index) => {
                                            let count = rows;
                                            if(rows < 2){rows += 1};

                                            return (
                                              <>{(count < 2)&&
                                                <li className="ring-row-wrapper">
                                                    <span className="liveclass_nameinfo">
                                                        <Link onClick={props.closePopup} to={classGroup.link}>{classGroup.group_name+' ('+classGroup.class_numbers+')'}</Link>
                                                    </span>
                                                    <span className="live_status">
                                                        <Link onClick={props.closePopup} to={classGroup.link}>{classGroup.time}</Link>
                                                    </span>
                                                </li>
                                            }</>)

                                        })}</>}
                                        {(ring.completed !== null && ring.completed !== undefined) &&
                                        <>{ring.completed.map((classGroup, index) => {
                                          let count = rows;
                                          if(rows < 2){rows += 1};

                                          return (
                                            <>{(count < 2)&&
                                                <li className="ring-row-wrapper">
                                                    <span className="liveclass_nameinfo">
                                                        <Link onClick={props.closePopup} to={classGroup.link}>{classGroup.group_name+' ('+classGroup.class_numbers+')'}</Link>
                                                    </span>
                                                    <span className="live_status">
                                                        <Link onClick={props.closePopup} to={classGroup.link}>completed</Link>
                                                    </span>
                                                </li>
                                            }</>)

                                          })}</>}

                                    </ul>
                                </div>
                            </div>

                        }
                    </>
                    );
                
                })}
              </div>
      </div>
    );
  

}

export default LiveClassWidget;
